import api from '../../../api';

export const checkInvoice = params => api.post('Execution/Check', {
  RequestWrapper: {
    codeBar: params.codebar,
    companyId: params.companyid,
    userId: params.userid,
    lstFields: params.answers,
  },
}).then(response => response.data);

export const executionByInvoiceId = invoiceid => api.get('Execution/ExecutionByInvoiceId', {
  params: { invoiceid },
}).then(response => response.data.return);



// WEBPACK FOOTER //
// ./src/redux/actions/tracker/executionActions.js